import { isInjuryHandoff } from "./incidentConstants";

const hasText = (value) => Boolean(String(value || "").trim());

export function validateIncidentSection(section, data) {
  const errors = {};

  if (section === 1) {
    if (!data.selectedManagerUid) errors.selectedManagerUid = "Select the manager who will receive this report.";
    if (!hasText(data.occurredDate)) errors.occurredDate = "Enter the incident date.";
    if (!hasText(data.occurredTime)) errors.occurredTime = "Enter the incident time.";
    if (!hasText(data.locationType)) errors.locationType = "Select the incident location type.";
    if (!hasText(data.address)) errors.address = "Enter the incident address or location.";
  }

  if (section === 2) {
    if (!hasText(data.incidentType)) errors.incidentType = "Select an incident type.";
    if (
      data.incidentType === "injury_illness" &&
      typeof data.typeDetails?.injury?.someoneInjuredOrAffected !== "boolean"
    ) {
      errors.someoneInjuredOrAffected = "Confirm whether someone was injured or affected.";
    }
    if (data.incidentType === "vehicle_accident" && !hasText(data.typeDetails?.vehicle?.greenspaceRegistration)) {
      errors.greenspaceRegistration = "Select or enter the Greenspace vehicle registration.";
    }
    if (data.incidentType === "environmental_spill_leak" && !hasText(data.typeDetails?.environmental?.eventType)) {
      errors.environmentalEventType = "Select what occurred.";
    }
  }

  if (section === 3 && !hasText(data.description)) {
    errors.description = "Describe what happened.";
  }

  if (section === 4 && !data.selected?.length) {
    errors.selected = "Select at least one immediate action.";
  }

  if (section === 5 && typeof data.witnessesPresent !== "boolean") {
    errors.witnessesPresent = "Confirm whether there were witnesses.";
  }

  return errors;
}

export function firstIncompleteSection(incident) {
  const sections = incident?.partA || {};
  for (let section = 1; section <= 5; section += 1) {
    if (Object.keys(validateIncidentSection(section, sections[`section${section}`] || {})).length) {
      return section;
    }
    if (section === 2 && isInjuryHandoff(sections.section2)) return 2;
  }
  return 6;
}
